/**
 * Shared eyebrow-style toggle look for status/template filter rows — `Home.tsx`'s `All · Live ·
 * Draft · Finished` row and `AdminRooms.tsx`'s status filter both render the same pill, so the
 * class list lives here once rather than drifting between the two.
 */
export function filterPillClass(active: boolean): string {
  return [
    'eyebrow min-h-tap rounded-full border px-3',
    active ? 'border-accent text-accent' : 'border-border-strong text-text-faint hover:text-text',
  ].join(' ');
}
